import React from "react";
// import {NotificationOrderForm} from "./NotificationOrderForm";
import {NotificationOrderForm2} from "./NotificationOrderForm2";

export function NotificationOrderList({ data, order_key }) {
    return (
        <div className="row">
            {data.optionList.map((item, i) =>
                <div className="col-xl-4" key={"notification-" + i}>
                    <NotificationOrderForm2 data={item} order_key={order_key}/>
                </div>
            )}
        </div>
    )

}